import React from 'react';
import PageHeader from 'components/PageHeader';
import { Segment } from 'semantic-ui-react';
import SwitchRouter from 'components/SwitchRouter';
import { Route } from 'react-router-dom';
import Menu from './Menu';
import DigitarEventos from './DigitarEventos';
import ListarDigitacao from './ListarDigitacoes';
import TrackerReport from '../tracker/TrackerReport';

export default function Inicio({ match: { path } }) {
    return (
        <div id="template-departamento" className="page-content">
            <PageHeader compact />

            <Segment className="subcontent py-0">
                <SwitchRouter>
                    <Route
                        exact
                        path={`${path}`}
                        render={(props) => <Menu {...props} path={path} />}
                    />
                    <Route
                        exact
                        path={`${path}/digitar-eventos`}
                        restricted="departamento-pessoal>saveDigitacao"
                        render={(props) => <DigitarEventos {...props} path={path} />}
                    />
                    <Route
                        exact
                        path={`${path}/listar-digitacoes`}
                        restricted="departamento-pessoal>list"
                        render={(props) => <ListarDigitacao {...props} path={path} />}
                    />
                    <Route
                        exact
                        path={`${path}/rastreio-de-atividades`}
                        render={(props) => <TrackerReport {...props} path={path} />}
                    />
                </SwitchRouter>
            </Segment>
        </div>
    );
}
